export var ICatalogServiceImageItemType = /*#__PURE__*/ function(ICatalogServiceImageItemType) {
    ICatalogServiceImageItemType["icon"] = "icon";
    ICatalogServiceImageItemType["screenshot"] = "screenshot";
    return ICatalogServiceImageItemType;
}({});
export var CatalogOfferType = /*#__PURE__*/ function(CatalogOfferType) {
    CatalogOfferType["ConsultingServices"] = "ConsultingServices";
    return CatalogOfferType;
}({});
export var CatalogStorefrontRatingSource = /*#__PURE__*/ function(CatalogStorefrontRatingSource) {
    CatalogStorefrontRatingSource["Internal"] = "Internal";
    CatalogStorefrontRatingSource["G2"] = "G2";
    return CatalogStorefrontRatingSource;
}({});
